import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import styles from './Fontbar.module.css';
import { Frame, useMotionValue, useTransform } from 'framer';

import { AppContext } from '../../services/AppContext';

export function Fontbar({ size, onChange, theme }) {
	const { locale } = useContext(AppContext);
	const width = 200;

	const { slider } = theme;

	const { background, accentColor, color, knob } = slider;

	const [percent, setPercent] = useState((size * width) / 100);
	const position = useMotionValue(percent);

	useEffect(() => {
		setPercent((size * width) / 100);
	}, [size]);

	if (size === undefined) {
		return null;
	}

	return (
		<div
			className={styles[`font-size-option-holder`]}
			style={{ background: background }}
		>
			<div>
				<div className={styles['font-icon-container']}>
					<div
						className={`${styles['fontbar-icon']} ${styles['icon-font-decrease']}`}
					>
						<button
							onClick={() => {
								let decreaseSize = size - 10;
								if (decreaseSize <= 5) {
									decreaseSize = 5;
								}
								position.set((decreaseSize * width) / 100);
								onChange(decreaseSize);
							}}
							title={locale['BUTTON_TITLE_FONT_SIZE_DECREASE']}
							style={{ background: color }}
						/>
					</div>
				</div>
				<div className={styles['font-slider-container']}>
					<Slider
						min={5}
						max={100}
						knob={knob}
						position={position}
						background={accentColor}
						onChange={onChange}
						width={width}
					/>
				</div>
				<div className={styles['font-icon-container']}>
					<div
						className={`${styles['fontbar-icon']} ${styles['icon-font-increase']}`}
					>
						<button
							onClick={() => {
								let increaseSize = size + 10;
								if (increaseSize >= 100) {
									increaseSize = 100;
								}
								position.set((increaseSize * width) / 100);
								onChange(increaseSize);
							}}
							title={locale['BUTTON_TITLE_FONT_SIZE_INCREASE']}
							style={{ background: color }}
						/>
					</div>
				</div>
			</div>
		</div>
	);
}

Fontbar.propTypes = {
	size: PropTypes.number.isRequired,
	onChange: PropTypes.func.isRequired,
	theme: PropTypes.object,
};

function Slider({ width, min, max, onChange, knob, background, position }) {
	width = width || 200;
	background = background || '#000000';

	let knobSize = knob.size || 20;

	const newPercent = useTransform(position, [0, width], [min, max]);

	if (typeof knobSize === 'string') {
		knobSize = JSON.parse(knobSize);
	}

	let offset = -1 * (knobSize / 2);
	return (
		<Frame
			name={'Rail'}
			width={width}
			height={6}
			center
			background={'rgba(0,0,0,.2)'}
			radius={3}
		>
			<Frame
				name={'Fill'}
				width={position}
				height={6}
				radius={3}
				background={background}
			/>
			<Frame
				name={'Knob'}
				size={knobSize}
				center={'y'}
				radius={'50%'}
				background={knob.color}
				shadow={'0 1px 3px 1px #242424'}
				left={offset}
				drag={'x'}
				x={position}
				dragConstraints={{ left: 0, right: width }}
				dragElastic={0}
				dragMomentum={false}
				onDrag={() => {
					if (onChange) onChange(newPercent.get());
				}}
			/>
		</Frame>
	);
}

Slider.propTypes = {
	width: PropTypes.number.isRequired,
	min: PropTypes.number.isRequired,
	max: PropTypes.number.isRequired,
	onChange: PropTypes.func.isRequired,
	knob: PropTypes.object.isRequired,
	background: PropTypes.string,
	position: PropTypes.object,
};

export default Fontbar;
